var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBulletChecklist = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#1E2969",
    strokeWidth: 2,
    fill: "#F6C760",
    cx: 25,
    cy: 25,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h30v30H10z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1E2969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.973 32.958H15.996V17.753h14.977v.798l2.997-2.507v-1.333H13V36h20.97V22.81l-2.997 3.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.893 20.847-1.157 1.28 7.391 8.652L39 15.098 37.985 14l-11.858 9.908z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBulletChecklist);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bullet-checklist.e8dbe24393846aa97747bfb3c4742c3d.svg";